import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    heading: "Introduction",
    body: [
      "These Terms & Conditions govern the services provided by The Foundation Edit. By purchasing a service or working with us, you agree to the terms outlined below.",
    ],
  },
  {
    heading: "Services",
    body: [
      "The Foundation Edit provides business setup and backend systems services for service-based businesses, including onboarding systems, workflows, templates, backend organisation, payment setup, and operational structure.",
    ],
  },
  {
    heading: "Client Responsibilities",
    body: [
      "Clients agree to provide accurate information, respond in a timely manner, and maintain access to any required platforms or accounts. Delays in communication may impact project timelines.",
    ],
  },
  {
    heading: "Payments",
    body: [
      "All payments must be made in full unless otherwise agreed in writing. Work will not begin until payment has been received.",
    ],
  },
  {
    heading: "Refunds",
    body: [
      "Due to the customised and digital nature of our services, payments are non-refundable once work has commenced.",
    ],
  },
  {
    heading: "Turnaround Times",
    body: [
      "Estimated turnaround times may vary depending on project complexity and client responsiveness.",
    ],
  },
  {
    heading: "Revisions",
    body: [
      "Reasonable refinements may be included within your package. Additional requests outside the agreed scope may incur extra fees.",
    ],
  },
  {
    heading: "Intellectual Property",
    body: [
      "Materials created by The Foundation Edit remain our intellectual property until full payment has been received. Materials may not be resold or redistributed.",
    ],
  },
  {
    heading: "Limitation of Liability",
    body: [
      "The Foundation Edit is not responsible for business performance, third-party platform issues, or misuse of delivered systems.",
    ],
  },
  {
    heading: "Contact",
    body: [],
    contact: "info@thefoundationedit.co.uk",
  },
];

export default function Terms() {
  return (
    <LegalPage
      overline="Legal"
      title="Terms & Conditions"
      lastUpdated="April 2026"
      sections={sections}
    />
  );
}
